import { render, staticRenderFns } from "./Branches.vue?vue&type=template&id=32896830"
import script from "./Branches.vue?vue&type=script&lang=ts"
export * from "./Branches.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports